export default __webpack_public_path__ + "images/87deb5a1419f6870ba202fbaab114014.svg";